'use strict';
const angular = require('angular');

/*@ngInject*/
export function TemplatesService($resource) {
  return $resource('/api/templates/:id', {
    id: '@_id'
  },{
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduuApp.TemplateService', [])
  .factory('TemplateService', TemplatesService)
  .name;



// WEBPACK FOOTER //
// ./client/components/templates/templates.service.js